import Vue from 'vue'
import App from './Download.vue'
import {SupportRouter} from './router'
import {installGoogleAnalytics} from "@/components/Analytics";

Vue.config.productionTip = false

installGoogleAnalytics();

new Vue({
  router: SupportRouter,
  render: h => h(App)
}).$mount('#app')
